import { useEffectOnce } from 'react-use';

export const usePromotionView = (promotions, ref) => {
  useEffectOnce(() => {
    if (promotions && promotions.length === 0) return null;

    const promoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          window.dataLayer.push({
            event: 'promotionView',
            ecommerce: {
              promoView: {
                promotions
              }
            }
          });
          observer.unobserve(ref.current);
        }
      });
    });
    promoObserver.observe(ref.current);
    return () => {
      promoObserver.disconnect();
    };
  });
};
